import Service from "../../../Services/index";
import moment from "moment"

const leaveDay = {
    namespaced: true,
    state: {
        leaveDayList:[],
        leaveDayAll:[],
        leaveDayForm:{
            id : "",
            name : "",
            how_long_month : "",
            how_long_day : "",
            user_id : "",
            number_of_leave : '',
        },
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        GET_LEAVEDAY_LIST: (state, res) => {
            state.leaveDayList = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.total
            }
        },
        GET_LEAVEDAY_BY_ID: (state, res) => {
            state.leaveDayForm = res;
        },
        CLEAR_DATA_FORM: state=>{
            state.leaveDayForm ={
                id : "",
                name : "",
                how_long_month : "",
                how_long_day : "",
                user_id : "",
                number_of_leave : '',
            };
        },
        GET_LEAVEDAY_ALL:(state,res)=>{
            state.leaveDayAll = res;
        }
    },
    actions: {
        setLeaveDay({commit},page=1){
            return Service.LeaveDay.getLeaveDay(page).then(response => {
                commit("GET_LEAVEDAY_LIST", response);
            });
        },
        setLeaveDayAll({commit}){
            return Service.LeaveDay.getLeaveDayAll().then(response => {
                commit("GET_LEAVEDAY_ALL", response);
            });
        },
        showLeaveDayById({commit},id){
            return Service.LeaveDay.showLeaveDay(id).then(response => {
                commit("GET_LEAVEDAY_BY_ID", response);
            });
        },
        saveLeaveDay({state},{id,data}){
            if(!id){
                return Service.LeaveDay.createLeaveDay(data).then(res=>{
                });
            }else{
                return Service.LeaveDay.updateLeaveDay(id,data).then(res=>{
                });
            }
        },
        deleteLeaveDay({commit},id){
            return Service.LeaveDay.deleteLeaveDay(id);
        },
        clearData({commit}){
            commit("CLEAR_DATA_FORM");
        },
        getLeaveHour({commit}){
            return Service.LeaveDay.getLeaveHour();
        },
        search({commit},data){
            return Service.LeaveDay.searchLeaveDay(data).then(res=>{
                commit("GET_LEAVEDAY_LIST", res);
            });
        }
    }
};
export default leaveDay;
